<template>
  <div>
    <slot></slot>

    <div class="w3-main" style="margin-left:200px;">
      <WorkspaceTopbar>
        <template slot="header">
          <i class="fa fa-border-all light-text2"></i> {{ main_project.name.slice(0,7) }}.. {{ isTodo.length+isProgress.length }}
        </template>
      </WorkspaceTopbar>

      <div v-if="isProgress.length > 0">
        <div class="w3-padding w3-small light-text sub-head">
          In Progress {{isProgress.length}}
        </div>
        <IssueTemplate v-for="item in isProgress" :issue="item" :key="item.id" />
      </div>

      <div v-if="isTodo.length > 0">
        <div class="w3-padding w3-small light-text sub-head">
          Todo {{isTodo.length}}
        </div>
        <IssueTemplate v-for="item in isTodo" :issue="item" :key="item.id" />
      </div>

      <div v-if="!isProgress.length && !isTodo.length">
        <IssueEmptyMinimal/>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import WorkspaceTopbar from "@/components/workspace/WorkspaceTopbar.vue"
import IssueTemplate from "@/components/workspace/issues/IssueTemplate.vue"
import IssueEmptyMinimal from "@/components/workspace/Empty/IssueEmptyMinimal.vue"

// IN progress-> 3
// IN todo-> 4
// IN backlog-> 5

export default {
  name: 'ProjectBase',

  components:{
    WorkspaceTopbar,
    IssueTemplate,
    IssueEmptyMinimal
  },

  methods: {
    // ...mapActions('workspace', ['getIssues']),
  },

  created: function () {
  },

  computed: {
    ...mapGetters('auth', ['auth_state', 'user', 'isLoggedIn', 'workspaces']),
    ...mapGetters('workspace', ['ws_issues', 'ws_projects']),
    ...mapState('workspace', ['issues']),


    workspace: function(){
      const result = this.workspaces.find( ({ slug }) => slug === this.$route.params.slug );
      return result;
    },

    sortedIssues: function () {
      return this.ws_issues.filter(
        w => w.project_id === this.ws_projects.find(({ slug }) => slug === this.$route.params.projectslug).id
      )
    },

    main_project: function(){
      const result = this.ws_projects.find( ({ slug }) => slug === this.$route.params.projectslug );
      return result;
    },

    isTodo: function () {
      // TO_DO ID OS 4
      const result = this.sortedIssues.filter(function( obj ) {
          return obj.status === 4;
      });
      return result;
    },


    isProgress: function () {
      // Progress ID IS 3
      const result = this.sortedIssues.filter(function( obj ) {
          return obj.status === 3;
      });
      return result;
    }
  }
}
</script>

<style scoped>

</style>
